<template>
  <form @submit.prevent="submit" class="questionnaire-preferences-form">
    <div>
      <h3>Default Questionnaires</h3>
      <div class="data-row" v-for="(item, index) in questionnaires" :key="index">
        <rp-checkbox class="data-item"
          v-model="item.isSelected"
          :label="item.description"
        />
        <div class="data-explanation">{{item.explanation}}</div>
      </div>
    </div>
    <div v-if="oneWeekToggleEnabled">
      <hr />
      <h3>Questionnaire at 1 Week</h3>
      <rp-radios
        label="This questionnaire will be sent at the 1 week time-point">
        <rp-radio
          v-model="oneWeekQuestionnaireId"
          name="radio"
          :bit="oneWeekPrimaryId"
          label="RayPRO Default" />
        <rp-radio
          v-model="oneWeekQuestionnaireId"
          name="radio"
          :bit="oneWeekSecondaryId"
          label="PHIN Patient Feedback" />
      </rp-radios>
    </div>
    <div v-if="oneMonthToggleEnabled">
      <hr />
      <h3>Questionnaire at 1 Month</h3>
      <rp-radios
        label="This questionnaire will be sent at the 1 month time-point">
        <rp-radio
          v-model="oneMonthQuestionnaireId"
          name="radio"
          :bit="oneMonthPrimaryId"
          label="Cat-PROM5" />
        <rp-radio
          v-model="oneMonthQuestionnaireId"
          name="radio"
          :bit="oneMonthSecondaryId"
          label="Catquest-9SF" />
      </rp-radios>
    </div>
    <rp-button :disabled="isInvalid" type="primary">Confirm</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import form from '../../../mixins/form'
  import Button from '../../../components/ui/inputs/Button'
  import Checkbox from '../../../components/ui/inputs/Checkbox'
  import Radio from '../../../components/ui/inputs/Radio'
  import Radios from '../../../components/ui/inputs/Radios'

  export default {
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-checkbox': Checkbox,
      'rp-radio': Radio,
      'rp-radios': Radios,
    },

    props: {
      questionnaires: Array,
      surgeonQuestionnaires: Array,
      oneWeekQuestionnaires: Array,
      oneMonthQuestionnaires: Array,
    },

    data() {
      return {
        oneWeekPrimaryId: '',
        oneWeekSecondaryId: '',
        oneWeekQuestionnaireId: '',
        oneMonthPrimaryId: '',
        oneMonthSecondaryId: '',
        oneMonthQuestionnaireId: '',
        selectedQuestionnaireIds: [],
      }
    },

    mounted() {
    },

    computed: {
      oneWeekToggleEnabled() {
        return this.oneWeekQuestionnaires.length > 1 &&
          (this.selectedQuestionnaireIds.includes(this.oneWeekPrimaryId)
          || this.selectedQuestionnaireIds.includes(this.oneWeekSecondaryId))
      },

      oneMonthToggleEnabled() {
        return this.oneMonthQuestionnaires.length > 1 &&
          (this.selectedQuestionnaireIds.includes(this.oneMonthPrimaryId)
          || this.selectedQuestionnaireIds.includes(this.oneMonthSecondaryId))
      },
    },

    methods: {
      submit() {
        this.$emit('submit', this.selectedQuestionnaireIds)
      },

      onQuestionnairesChanged() {
        this.selectedQuestionnaireIds = []
        this.questionnaires.forEach((element) => {
          if (element.isSelected) {
            this.selectedQuestionnaireIds.push(element.id)
          }
        })
      },

      onOneWeekQuestionnairesChanged() {
        let rpDefault = this.oneWeekQuestionnaires.find(
          (x) => x.name === '1-week-questionnaire'
        )
        let phin = this.oneWeekQuestionnaires.find(
          (x) => x.name === '1-week-phin'
        )
        this.oneWeekPrimaryId = (rpDefault) ? rpDefault.id : ''
        this.oneWeekSecondaryId = (phin) ? phin.id : ''

        if (rpDefault) this.$set(rpDefault, 'isSelected', true)
        if (phin) this.$set(phin, 'isSelected', true)

        if (this.surgeonQuestionnaires.includes(this.oneWeekPrimaryId)) {
          this.oneWeekQuestionnaireId = this.oneWeekPrimaryId
        } else if (this.surgeonQuestionnaires.includes(this.oneWeekSecondaryId)) {
          this.oneWeekQuestionnaireId = this.oneWeekSecondaryId
        }
      },

      onOneMonthQuestionnairesChanged() {
        let catprom = this.oneMonthQuestionnaires.find(
          (x) => x.name === '1-month-questionnaire'
        )
        let catquest = this.oneMonthQuestionnaires.find(
          (x) => x.name === '1-month-catquest'
        )
        this.oneMonthPrimaryId = (catprom) ? catprom.id : ''
        this.oneMonthSecondaryId = (catquest) ? catquest.id : ''

        if (catprom) this.$set(catprom, 'isSelected', true)
        if (catquest) this.$set(catquest, 'isSelected', true)

        if (this.surgeonQuestionnaires.includes(this.oneMonthPrimaryId)) {
          this.oneMonthQuestionnaireId = this.oneMonthPrimaryId
        } else if (this.surgeonQuestionnaires.includes(this.oneMonthSecondaryId)) {
          this.oneMonthQuestionnaireId = this.oneMonthSecondaryId
        }
      },

      onSurgeonQuestionnairesChanged() {
        this.questionnaires.forEach((x) => {
          if (this.surgeonQuestionnaires.includes(x.id)) {
            this.$set(x, 'isSelected', true)
          } else {
            this.$set(x, 'isSelected', false)
          }
        })
      },

      onOneWeekQuestionnaireIdChanged() {
        let oneWeek = this.oneWeekQuestionnaires.find(
          (x) => x.id === this.oneWeekQuestionnaireId
        )
        this.questionnaires.splice(0, 1, oneWeek)
      },

      onOneMonthQuestionnaireIdChanged() {
        let oneMonth = this.oneMonthQuestionnaires.find(
          (x) => x.id === this.oneMonthQuestionnaireId
        )
        this.questionnaires.splice(1, 1, oneMonth)
      }
    },

    watch: {
      questionnaires: {
        handler: function (_val) {
          this.onQuestionnairesChanged()
        },
        deep: true
      },

      oneWeekQuestionnaires: {
        handler: function (_val) {
          this.onOneWeekQuestionnairesChanged()
        },
      },

      oneMonthQuestionnaires: {
        handler: function (_val) {
          this.onOneMonthQuestionnairesChanged()
        },
      },

      surgeonQuestionnaires: {
        handler: function (_val) {
          this.onSurgeonQuestionnairesChanged()
        },
      },

      oneWeekQuestionnaireId: {
        handler: function (_val) {
          this.onOneWeekQuestionnaireIdChanged()
        },
      },

      oneMonthQuestionnaireId: {
        handler: function (_val) {
          this.onOneMonthQuestionnaireIdChanged()
        },
      },
    },

    validations: {
      selectedQuestionnaireIds: {
        notEmpty() {
          return this.selectedQuestionnaireIds.length > 0
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
  .questionnaire-preferences-form
    font-size: 1.4em
    padding: 20px

    .data-row
      display: flex    
      align-items: center

      .data-item
        width: 300px

      .data-explanation
        width: 400px 
        font-weight: 400

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/QuestionnairePreferences.vue